module.exports = __webpack_public_path__ + "img/grab-dots-icon.7c9d2e89.svg";